import React from "react";
import SidebarHeader from "./SidebarHeader";
import SidebarLinkGroup from "./SidebarLinkGroupDesktop";
import SidebarFooter from "./SidebarFooter";
import SidebarMobile from "./SidebarLinkGroupMobile";
const index = () => {
  return (
    <>
      <div className="relative left-0 top-0 z-9999 flex  w-[20%] px-[16px] py-[10px] hidden lg:flex lg:flex-col  h-screen flex-col overflow-y-hidden  duration-300 ease-linear bg-[#0E1E2D] lg:static lg:translate-x-0">
        <SidebarHeader />
        <div>
          <SidebarLinkGroup />  
        </div>
        <SidebarFooter />
      </div>

      <div className="w-[100%]  static bottom-0 lg:hidden bg-[#0E1E2D] rounded-tl-[16px] rounded-tr-[16px]">
        <SidebarMobile />
      </div>
    </>
  );
};

export default index;
